import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=e2e1b668&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=e2e1b668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e1b668",
  null
  
)

export default component.exports